import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useStyles } from './style';

/**
 * @name CustomAccordion
 * @description Menu that displays list of nav links
 * @param {object} root0  - destructured object
 * @param {object} root0.title  - Title of navs in mobile view
 * @param {object} root0.description  - Description of navs in mobile view
 * @returns {JSX.Element} - Menu list that displays nav links
 */
const CustomAccordion = ({ title, description }) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  return (
    <Accordion sx={styles.collapseContainer} square>
      <AccordionSummary
        expandIcon={
          <ArrowDropDownIcon fontSize='medium' sx={{ color: theme.palette.default.textColor3 }} />
        }
        sx={styles.summary}
      >
        <Typography variant='h5' sx={styles.title}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={styles.details}>
        <Typography variant='h5' sx={styles.descriptionText}>
          {description}
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
};

export default CustomAccordion;
